<template>
  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
    <div
      class="teacher__item text-center grey-bg-5 transition-3 mb-30 d-flex flex-column"
    >
      <div class="teacher__thumb w-img fix">
        <img
          class="teacher__img"
          style="
            object-fit: cover;
            object-position: center;
            border-radius: 6px;
            width: 100%;
            height: 100%;
          "
          :src="baseUrl + leader.image"
          alt=""
        />
      </div>
      <div class="teacher__content flex-grow-1 d-flex flex-column pb-0">
        <h2 class="teacher__title">
          {{
            getName({
              nameUz: leader.full_name_uz ?? "",
              nameRu: leader.full_name_ru ?? "",
              nameEn: leader.full_name_en ?? "",
            })
          }}
        </h2>

        <span class="mb-2">
          {{
            getName({
              nameUz: leader.postion_uz ?? "",
              nameRu: leader.postion_ru ?? "",
              nameEn: leader.postion_en ?? "",
            })
          }}
        </span>

        <div class="d-flex items-center mt-2">
          <img
            width="22"
            style="margin-right: 6px"
            src="../../assets/img/phone.png"
            alt=""
          />
          <span>{{ leader.phone ?? "" }}</span>
        </div>

        <div class="d-flex items-center my-2">
          <img
            width="22"
            style="margin-right: 6px"
            src="../../assets/img/email.png"
            alt=""
          />
          <span>{{ leader.email ?? "" }}</span>
        </div>

        <div class="d-flex items-center">
          <img
            width="22"
            style="margin-right: 6px"
            src="../../assets/img/time.png"
            alt=""
          />
          <span>
            {{
              getName({
                nameUz: leader.res_uz ?? "",
                nameRu: leader.res_ru ?? "",
                nameEn: leader.res_en ?? "",
              })
            }}
          </span>
        </div>

        <div class="teacher__btn mt-auto pt-3">
          <router-link
            :to="`/instructor-details?id=${leader.id}`"
            class="link-btn"
          >
            {{ $t("actions.detail") }}
            <i class="far fa-arrow-right"></i>
            <i class="far fa-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogMixin from "../../mixins/blogMixin";

export default {
  name: "LeaderCard",
  mixins: [BlogMixin],
  props: {
    leader: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.teacher__thumb {
  width: 100%;
  aspect-ratio: 6 / 5;
  overflow: hidden;
}

.teacher__img {
  display: block;
}

.teacher__content {
  min-height: 180px;
  padding: 20px;
}

.teacher__btn {
  margin-top: auto;
}
</style>
